export const FILE_STATUS = Object.freeze({
  notFound: 'NOT_FOUND',
  building: 'BUILDING',
  done: 'DONE',
  fail: 'FAIL'
});
